import cx from 'classnames';

import typography from '~styles/typography.scss';
import type { Message } from './apiHelpers';
import styles from './InboxConversationRow.scss';

interface InboxConversationRowProps {
  notification: Message;
  timestampLabel: string;
  isSelected?: boolean;
}

export const InboxConversationRow = ({
  notification,
  timestampLabel,
  isSelected = false,
}: InboxConversationRowProps) => {
  return (
    <div className={cx(styles.row, { [styles.selected]: isSelected })}>
      <div className={styles.body}>
        <div
          className={cx(styles.status, {
            [styles.unread]: !notification.readAt,
          })}
        />
        <div className={styles.textBlock}>
          <div className={styles.nameRow}>
            <span className={cx(typography.h6, styles.guestName)}>
              {notification.user.firstName} {notification.user.lastName}
            </span>
            <span className={cx(typography.t2, styles.timestamp)}>
              {timestampLabel}
            </span>
          </div>
          <span className={styles.preview}>{notification.message}</span>
        </div>
      </div>
    </div>
  );
};
